import React from 'react';
import Proptypes from 'prop-types';
import ActivityOption from '../activityOption/ActivityOption';
import './DiningSummary.scss';

const DiningSummary = ({ label, dinings = [] }) => (
  <div className="dining">
    <div className="title">Dining</div>
    <div className="label">{label}</div>
    <div className="dining-cards">
      {
        dinings.length > 0 && dinings.map(({ name, time, color, redirectPath, isDisabled }) => (
          <ActivityOption
            key={redirectPath}
            name={name}
            time={time}
            color={color}
            redirectPath={redirectPath}
            isDisabled={isDisabled}
          />
        ))
      }
    </div>
  </div>
);

DiningSummary.propTypes = {
  label: Proptypes.string.isRequired,
  dinings: Proptypes.array.isRequired,
};

export default DiningSummary;
